import { toNumber } from '@aibees/shared/utils';
import { TablePaginationProps } from '@mui/material';
import { range } from 'lodash-es';
import { memo } from 'react';
import { DropDown, DropDownOption } from '../drop-down';

type Props = {
  count: number;
  current: number;
  onChange: TablePaginationProps['onPageChange'];
};

export const TablePageSelector = memo(({ count, current, onChange }: Props) => {
  const options: DropDownOption[] = range(0, count > 100 ? 100 : count).map(
    (x) => ({
      key: String(x),
      value: x,
      label: (x + 1).toString(),
    })
  );

  return (
    <DropDown
      options={options}
      value={current}
      size="small"
      MenuProps={{
        anchorOrigin: { vertical: 'top', horizontal: 'left' },
        transformOrigin: { vertical: 'bottom', horizontal: 'left' },
        MenuListProps: {
          sx: { maxHeight: 200 },
        },
      }}
      onChange={(e) => onChange({} as any, toNumber(e) ?? 0)}
    />
  );
});
